export default class ReturnVisitPhotoInputDto {
/**
 *
 * @type {string}
 * @memberof ReturnVisitPhotoInputDto
 */
maintainRecordId?: any
/**
 *
 * @type {Array&lt;string&gt;}
 * @memberof ReturnVisitPhotoInputDto
 */
urls?: any | null
}
